<template>
  <div class="empty-block">
    <EmptyBlockImage />
    <p class="empty-block__text">{{ t('empty-text') }}</p>
  </div>
</template>

<script setup lang="ts">
  import EmptyBlockImage from './EmptyBlockImage.vue';
  import { useI18n } from '@experience/i18n';
  import ru from './../i18n/ru.json';

  const { t } = useI18n({
    inheritLocale: true,
    messages: { ru },
  });
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography';

  .empty-block {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-16);
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding: 56px 0 0;

    &__text {
      margin: 0;
      padding: 0;
      color: var(--alias-color-text-default);
      text-align: center;

      @include typography.base-400-400-regular;
    }
  }
</style>
